import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import SectionHeading from '@/components/base/SectionHeading';

export default function CategoryNav() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 md:px-6" aria-label="漫画分类导航">
      <SectionHeading title="热门分类" subtitle="六大品类海量作品，总有一部让你上头" moreTo="/category" moreLabel="全部分类" />
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6 md:gap-4">
        {categories.map((cat) => (
          <Link
            key={cat.id}
            to={`/category/${cat.id}`}
            className="group flex flex-col items-center rounded-lg border border-background-200 bg-background-50 px-3 py-5 text-center transition-colors hover:border-primary-300 hover:bg-primary-50 md:px-4 md:py-6"
          >
            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-secondary-100 text-secondary-900 transition-colors group-hover:bg-primary-500 group-hover:text-background-50 md:h-12 md:w-12">
              <i className={`${cat.icon} h-5 w-5`} aria-hidden="true"></i>
            </span>
            <span className="mt-3 text-sm font-bold text-foreground-900 md:text-base">{cat.name}</span>
            <span className="mt-1 text-[11px] text-foreground-500 md:text-xs">{cat.count} 部作品</span>
          </Link>
        ))}
      </div>
    </section>
  );
}